var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 20,
    fill: "#06BA63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992,
    clipPath: "url(#clip0_2046_58076)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0855 26.1615H45.173C41.0255 26.1687 37.6655 29.4371 37.658 33.4716C37.6524 37.5153 41.0161 40.7982 45.173 40.8036H54.093V41.4461C54.093 48.4996 49.807 52.6706 42.5539 52.6706H23.541C16.286 52.6706 12 48.4996 12 41.4461V26.0832C12 19.0296 16.286 14.875 23.541 14.875H42.5464C49.7995 14.875 54.0855 19.0296 54.0855 26.0832V26.1615ZM21.9751 26.145H33.8454H33.8528H33.8678C34.7565 26.1414 35.4748 25.4371 35.4711 24.5709C35.4673 23.7064 34.7414 23.0076 33.8528 23.0113H21.9751C21.0921 23.0149 20.3756 23.7119 20.3719 24.5727C20.3681 25.4371 21.0865 26.1414 21.9751 26.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.5474 34.3996C41.9876 36.3968 43.7428 37.802 45.7467 37.7655H52.5866C53.4203 37.7655 54.0967 37.0766 54.0967 36.225V30.9094C54.0948 30.0597 53.4203 29.369 52.5866 29.3672H45.5856C43.3062 29.3745 41.4651 31.2621 41.4688 33.5883C41.4688 33.8606 41.4956 34.1328 41.5474 34.3996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.675 35.6604C46.8373 35.6604 47.7796 34.7203 47.7796 33.5607C47.7796 32.401 46.8373 31.4609 45.675 31.4609C44.5126 31.4609 43.5703 32.401 43.5703 33.5607C43.5703 34.7203 44.5126 35.6604 45.675 35.6604Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2046_58076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 39,
    fill: "white",
    transform: "translate(12 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv2);
export default __webpack_public_path__ + "static/media/div2.dd641b7d507dbc8c9fe13c6f42c7f452.svg";
export { ForwardRef as ReactComponent };